<ng-container *transloco="let t;">
    <div class="mi-content">
        <span [ngClass]="{ 'deleted-user': firstItem?.isDeleted }" [ngbTooltip]="firstItem?.isDeleted ? t('Deleted participant label (recipient list) - Deleted participant') : null" placement="top" container="body">
            {{ firstItem?.name }}
        </span>
        @if (tooltipItems.length > 0) {
            <span [ngbTooltip]="tooltipText" placement="top" container="body"
            >(+{{ tooltipItems.length }})</span>
        }
    </div>
</ng-container>
